export const ROUTES = {
  gettingStarted: '/docs-v2/getting-started',
  landingPageGuide: '/docs-v2/landing-page-guide',
  serviceManagement: "/docs-v2/service-management-api",
  releaseNotes: '/docs-v2/release-notes',
  registration: '/docs-v2/landing-page-guide/registration',
  environments: '/docs-v2/landing-page-guide/environments',
  troubleshooting: '/docs-v2/landing-page-guide/troubleshooting',
  support: '/docs-v2/landing-page-guide/support',
} as const;
